module.exports = __webpack_public_path__ + "img/misconduct.c3b3ef35.png";